export default [
    {
      sagaKey: 'oauthSaga',
      importSaga: () => import(/* webpackChunkName: "domain-oauth" */ 'modules/Oauth/store/saga'),
    },
]
